import { render } from "./activityManager.vue?vue&type=template&id=3836545e&scoped=true"
import script from "./activityManager.vue?vue&type=script&lang=js"
export * from "./activityManager.vue?vue&type=script&lang=js"

import "./activityManager.vue?vue&type=style&index=0&id=3836545e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3836545e"]])

export default __exports__